import React, { useEffect, useRef } from 'react';

import { cloudinaryUrl } from '@/utils/utils';
import { MissingImage, useBrokenImage } from '@/stories/atoms/MissingImage/MissingImage';
import styles from './gallery-image.module.css';

export interface GalleryImageProps {
  image: string,
  alt?: string,
  isSelected: boolean,
}

export const GalleryImage = ({ image, alt = '', isSelected}: GalleryImageProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const { broken, ref: imageRef, onError } = useBrokenImage()

  useEffect(() => {
    if (isSelected) {
      setTimeout(() => {
        ref?.current?.scrollIntoView({behavior: "smooth", block: "nearest"});
      }, 100)
    }
  }, [ref, isSelected])

  return (
    <div className={styles.wrapper} ref={ref}>
      {broken ? <MissingImage className={styles.missing} variant='large'/> : <img
        ref={imageRef}
        onError={onError}
        className={styles.image}
        width={1120}
        height={628}
        loading='lazy'
        sizes='(min-width: 60em) 1120px, calc(100vw - 32px)'
        src={cloudinaryUrl({src: image, width: 928, crop: 'limit', params: ['h_520']})}
        srcSet={`
          ${cloudinaryUrl({src: image, width: 343, crop: 'limit', params: ['h_200']})} 358w,
          ${cloudinaryUrl({src: image, width: 716, crop: 'limit', params: ['h_400']})} 716w,
          ${cloudinaryUrl({src: image, width: 735, crop: 'limit', params: ['h_413']})} 735w,
          ${cloudinaryUrl({src: image, width: 1470, crop: 'limit', params: ['h_826']})} 1470w,
          ${cloudinaryUrl({src: image, width: 1120, crop: 'limit', params: ['h_628']})} 1120w,
          ${cloudinaryUrl({src: image, width: 2240, crop: 'limit', params: ['h_1256']})} 2240w`}
        alt={alt} />}
    </div>
  )
};
